import { serviceImages } from "@/mocks/images";

const services = [
  {
    icon: "ri-building-2-line",
    title: "Construcción de Piscinas",
    desc: "Diseñamos y construimos piscinas a medida: enterradas, elevadas, de obra, prefabricadas o de poliéster. Adaptadas a tu espacio y presupuesto.",
    img: serviceImages.construccion,
    tag: "Más popular",
  },
  {
    icon: "ri-tools-line",
    title: "Mantenimiento de Piscinas",
    desc: "Servicio periódico de mantenimiento para mantener tu piscina en perfectas condiciones todo el año. Análisis de agua, limpieza y revisión de equipos.",
    img: serviceImages.mantenimiento,
    tag: null,
  },
  {
    icon: "ri-drop-line",
    title: "Limpieza Profesional",
    desc: "Limpieza a fondo del vaso, paredes, filtros y sistema de depuración. Agua cristalina y segura para toda la familia.",
    img: serviceImages.limpieza,
    tag: null,
  },
];

export default function Services() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="servicios" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-cyan-500 text-sm font-semibold uppercase tracking-widest">Nuestros Servicios</span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-800 mt-3 mb-4">
            Todo lo que necesitas para tu{" "}
            <span className="text-cyan-500">piscina perfecta</span>
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto text-base">
            Ofrecemos una solución integral para piscinas: desde la construcción hasta el mantenimiento diario, con la máxima calidad y profesionalismo.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((s) => (
            <div
              key={s.title}
              className="bg-white rounded-2xl overflow-hidden group hover:-translate-y-1 transition-all duration-300 border border-slate-100"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {s.tag && (
                  <span className="absolute top-3 right-3 bg-cyan-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                    {s.tag}
                  </span>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent"></div>
              </div>
              <div className="p-6">
                <div className="w-10 h-10 flex items-center justify-center bg-cyan-50 rounded-xl mb-4">
                  <i className={`${s.icon} text-cyan-500 text-xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-slate-800 mb-2">{s.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-14 text-center">
          <button
            onClick={() => scrollTo("contacto")}
            className="bg-cyan-500 hover:bg-cyan-600 text-white font-bold px-10 py-4 rounded-full text-base transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-cyan-500/20"
          >
            Solicita tu Presupuesto Gratis →
          </button>
        </div>


      </div>
    </section>
  );
}
